import {roles} from "../../utils/auth";
import {representativeExistCall, businessAccountManagerExistsCall} from "../../api/network/businessCustomerService";


export const USERS = "[Users]";

export const SET_USER = `${USERS} Set`;
export const PATCH_USER = `${USERS} Patch`;

export const saveUser = (user) => ({
    type: SET_USER,
    payload: {
        data: user
    }
});

export const patchUser = (userPartialUpdate) => ({
    type: PATCH_USER,
    payload: {
        data: userPartialUpdate
    }
});

export const findUser = (userId, userRole) => (dispatch) => {
    switch (userRole) {
        case roles.SMS:
        case roles.ADMIN:
        case roles.GK:{
            saveUser({exists: true});
            break;
        }
        case roles.COMPANY:{
            saveUser({exists: true});
            break;}
        case roles.CUSTOMER_REP:{
            // check to see if customer rep exist in db
            representativeExistCall(userId)
                .then(data => {
                    dispatch(saveUser(data))
                })
                .catch(error => {
                    console.error("Failed to fetch user", error);
                });
            break;
        }
        case roles.BAM:{
            // check to see if bam exists
            businessAccountManagerExistsCall(userId)
                .then(data => {
                    dispatch(saveUser(data))
                })
                .catch(error => {
                    console.error("Failed to fetch user", error);
                });
            break;
        }
        default:
            break
    }

};
